export default __webpack_public_path__ + "static/media/not-verify.7a70d6a5.svg";